import { j as e } from "../../../_virtual/jsx-runtime.js";
import p from "../SkeletonWrapper/index.js";
import f from "../Icon/index.js";
import { cn as s } from "../../../lib/utils.js";
const h = ({
  value: n,
  iconProps: l,
  label: t,
  isLoading: r,
  valueClasses: m,
  labelClasses: i,
  className: o = "",
  size: a
}) => {
  const c = s(
    a === "sm" ? "text-lg" : "text-xl",
    "leading-none",
    m
  ), x = s(
    a === "sm" ? "text-xs" : "text-sm",
    "leading-none",
    i
  );
  return /* @__PURE__ */ e.jsx(p, { isLoading: r, children: /* @__PURE__ */ e.jsx("div", { className: s(
    "flex flex-wrap gap-3 justify-between items-end leading-none self-center",
    o
  ), children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-baseline justify-start font-normal gap-2", children: [
    /* @__PURE__ */ e.jsx(f, { className: "w-5 h-5 self-center", ...l }),
    /* @__PURE__ */ e.jsx("span", { className: c, children: n }),
    t && /* @__PURE__ */ e.jsx("span", { className: x, children: t })
  ] }) }) });
};
export {
  h as default
};
